<nav class="nav-tabla">
  <ul>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/pendientes']"><span matBadge="{{documentos}}" matBadgeOverlap="false" matBadgeColor="warn">Pendientes de Validar</span></a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/adicional-pendientes']"><span matBadge="{{documentoAdic}}" matBadgeOverlap="false">Adicional Pendiente de Validar</span></a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/documentacion-caducada']">Doc. Caducada</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/documentacion-proxima']">Doc. Próxima</a>
    </li>
    
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/instalaciones']">Instalaciones</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/clientes']">Clientes</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/centros']">Centros</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/contratistas']">Contratistas</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/gestores']">Gestores</a>
    </li>
    <li routerLinkActive="activo">
      <a [routerLink]="['/inproeco/estado/transportistas']">Transportistas</a>
    </li>
  </ul>
</nav>
